import React from 'react';


const ArrowLeftIcon = ({className = ''}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" className={className}>
      <path d="M14 7.675C14 7.78546 13.9105 7.875 13.8 7.875H3.34833L8.09525 12.6219C8.17335 12.7 8.17335 12.8266 8.09525 12.9048L7.14142 13.8586C7.06332 13.9367 6.93668 13.9367 6.85858 13.8586L0.141421 7.14142C0.0633161 7.06332 0.0633165 6.93668 0.141421 6.85858L6.85858 0.141421C6.93668 0.0633163 7.06332 0.0633173 7.14142 0.141422L8.09525 1.09525C8.17335 1.17335 8.17335 1.29998 8.09525 1.37809L3.34833 6.125H13.8C13.9105 6.125 14 6.21454 14 6.325V7.675Z" fill="#666687" />
    </svg>
  );
};

export default ArrowLeftIcon;
